import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

export const compactEntityCardShellClass =
	'rounded-md border border-border bg-muted/10 p-1.5 border-l-[3px]';

interface CompactEntityCardProps {
	borderAccentClass: string;
	children: ReactNode;
	className?: string;
}

export default function CompactEntityCard({ borderAccentClass, children, className }: CompactEntityCardProps) {
	return (
		<div className={cn(compactEntityCardShellClass, borderAccentClass, className)}>
			{children}
		</div>
	);
}
